import { AccessType, LogInfo, LogInfoProps } from 'typings/logInfo'
import { create } from 'zustand'

export const useLogInfoStore = create<LogInfo>()(set => ({
    logInfo: {
        accessType: AccessType.NOT_INFORMED,
        userAgent: '',
        ipAddress: '',
        geolocation: '',
        accepted: false,
    },
    setLogInfo: (value: LogInfoProps) => set({ logInfo: value }),
}))
